import { CommonModule } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { HeaderConfigService, OnDestroyBase } from '@os-components';
import { Labels } from '@sew/ui-components';
import { SewVideo } from '@sew/ui-components-angular/standalone';
import { takeUntil } from 'rxjs';

@Component({
    selector: 'blog-youtube-player',
    templateUrl: './youtube-player.component.html',
    styleUrls: ['./youtube-player.component.scss'],
    imports: [CommonModule, SewVideo],
})
export class YoutubePlayerComponent extends OnDestroyBase implements OnInit {
    @Input() public videoSrc?: string;
    @Input() public caption?: string;

    public labels?: Labels;

    public constructor(private configService: HeaderConfigService) {
        super();
    }

    public ngOnInit(): void {
        this.configService.labelsChange
            .pipe(takeUntil(this.destroySubject))
            .subscribe((labels) => (this.labels = labels));
    }
}
